import { PanelProps } from '@blueprintjs/core';
import * as React from 'react';

import { refreshDataSources } from 'src/actions/data-sources/action-creators/refreshDataSources';
import {
  DataSourceTypeSelectionPanel,
  DataSourceTypeSelectionPanelProps,
} from 'src/containers/ProjectResourceDialog/DataSourceTypeSelectionPanel/DataSourceTypeSelectionPanel';
import {
  ProjectFileUploadCreationPanel,
  ProjectFileUploadCreationPanelProps,
} from 'src/containers/ProjectResourceDialog/ProjectFileUploadCreationPanel/ProjectFileUploadCreationPanel';
import { FileUploadTile } from 'src/containers/ProjectResourceDialog/ResourceTypePanel/FileUploadTile';
import { NewVirtualGraphTile } from 'src/containers/ProjectResourceDialog/ResourceTypePanel/NewVirtualGraphTile';
import { ProjectResourceDialogPanelProps } from 'src/containers/ProjectResourceDialog/types';
import * as copy from 'src/templates/copy';
import { useIsMounted } from 'src/utils/hooks/useIsMounted';
import { useReduxDispatch } from 'src/utils/hooks/useReduxDispatch';

export type ResourceTypePanelProps = ProjectResourceDialogPanelProps;

export const ResourceTypePanel: React.VFC<
  PanelProps<ResourceTypePanelProps>
> = ({ setFooterProps, openPanel }) => {
  const isMounted = useIsMounted();
  const dispatch = useReduxDispatch();
  React.useEffect(() => {
    if (isMounted.current) {
      setFooterProps({});
    }
  }, [isMounted, setFooterProps]);

  const handleDroppedFiles = (files: File[]) => {
    const [uploadedFile] = files;
    const props: ProjectFileUploadCreationPanelProps = {
      setFooterProps,
      uploadedFile,
    };
    openPanel({
      renderPanel: ProjectFileUploadCreationPanel,
      props,
    });
  };

  const handleRefreshDataSources = React.useCallback(() => {
    dispatch(refreshDataSources());
  }, [dispatch]);

  const handleProceedWithConnection = () => {
    const props: DataSourceTypeSelectionPanelProps = {
      setFooterProps,
    };
    handleRefreshDataSources();
    openPanel({
      renderPanel: DataSourceTypeSelectionPanel,
      props,
    });
  };

  return (
    <div className="sd-resource-type-panel">
      <p className="sd-resource-type-panel__description">
        {copy.components.projectResourceDialog.resourceTypePanel.description}
      </p>
      <div className="sd-resource-type-panel__tile-wrapper">
        <FileUploadTile handleDroppedFiles={handleDroppedFiles} />
        <NewVirtualGraphTile
          handleProceedWithConnection={handleProceedWithConnection}
        />
      </div>
    </div>
  );
};
